import { css, type Theme } from "@emotion/react";

export const slide = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.ds5.spacing.gap.medium};
  height: 100%;
  padding: 32px;
  text-align: center;
  background-color: ${theme.ds5.success.backgroundBold};
`;
